import React from "react";
import {Route} from "react-router-dom";


const module = (shopApp) => {
	const Checkout = shopApp.dynamic(() => import("./Checkout"));

	const url = "/checkout";

	let config = {
		name: "Checkout",
		routes: [
			<Route key={url} exact path={url} component={Checkout}/>
		]
	};

	shopApp.registerPage(config);

};

export default module;
